import type { ReactNode } from "react"
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material"
import { makeStyles } from "tss-react/mui"

export type PrintTableRow = Readonly<{
    key: string
    cells: ReadonlyArray<string>
}>

const useStyles = makeStyles()(() => ({
    title: {
        marginBottom: "1rem",
    },
}))

type Props = Readonly<{
    title: ReactNode
    headerCells: ReactNode
    rows: ReadonlyArray<PrintTableRow>
    empty: ReactNode
    className?: string
}>

export function PrintTable({ title, headerCells, rows, empty, className }: Props) {
    const { classes } = useStyles()

    return (
        <Box className={className}>
            <Box className={classes.title}>{title}</Box>
            {rows.length === 0 ? (
                empty
            ) : (
                <Table size="small">
                    <TableHead>
                        <TableRow>{headerCells}</TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow key={row.key}>
                                {row.cells.map((cell, index) => (
                                    <TableCell key={index}>{cell}</TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </Box>
    )
}
